import React, { Fragment } from "react";
//import PropTypes from "prop-types";
import { useReadContract } from "wagmi";
import { useQuery } from 'graphql-hooks';

import { MemoriesConfig } from "../services/web3";
import { ownersQuery } from "../services/queries/getOwned";
import EligibleLifeform from "./EligibleLifeform";
import Loader from "./Loader";

//import "../styles/InfoPanel.css";

const MintSetup = ({ address, setCarerMint, setBridgeMint }) => {
  const result = useReadContract({
      ...MemoriesConfig,
      functionName: 'allowlist',
      args: [address],
    })

  const gqlResult = useQuery(ownersQuery(address.toLowerCase()));

  const startCarerMint = () => {
    setCarerMint(true)
  }
    
  return (
    <div className="panel">
      <div className="panelContents">
      {result.isLoading || gqlResult.loading ? <Loader/> : null}
      {result.data ? (
        <Fragment>
          <p>You are in the memoryforms allowlist</p>
          <div className="button-parent padBottom">
            <button onClick={startCarerMint}>Proceed</button>
          </div>
        </Fragment>
      ) : <p>Sorry, you aren't in the memoryforms allow list. Did you interact with a lifeform before March 6, 2024?</p>}
      {gqlResult.data && gqlResult.data.owner ? (
        gqlResult.data.owner.lifeforms.map((i) => {
          return <EligibleLifeform key={i.id} id={i.id} setBridgeMint={setBridgeMint}/>
        })
      ) : null} 
      </div>
    </div>
  );
};

export default MintSetup;
